import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Typography,
  Grid,
  Box,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  Chip,
  Pagination,
  Paper,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Fade,
  Zoom,
  Grow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Avatar,
} from '@mui/material';
import {
  Search,
  LocationOn,
  Home,
  Business,
  Apartment,
  Hotel,
  TrendingUp,
  ArrowForward,
  Favorite,
  FavoriteBorder,
  Star,
  Pool,
  FitnessCenter,
  LocalParking,
  Wifi,
  Restaurant,
  Spa,
  Shield,
  Speed,
  Weekend,
  Close,
  Bed,
  Bathtub,
  SquareFoot,
  Phone,
  Email,
} from '@mui/icons-material';

// Property data with ALL RESIDENTIAL properties - NO COMMERCIAL SPACES
const allProperties = [
  {
    id: 1,
    title: 'Luxury 3BHK Sea View Apartment',
    type: 'Sale',
    location: 'Mumbai',
    price: '₹2.5 Cr',
    originalPrice: '₹2.8 Cr',
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&auto=format',
    rating: 4.8,
    reviews: 89,
    beds: 3,
    baths: 2,
    sqft: 1850,
    featured: true,
    amenities: ['Pool', 'Gym', 'Parking', 'Security'],
    area: 'Bandra West',
    description: 'Experience luxury living in this stunning sea view apartment located in the heart of Bandra West. Perfect for families seeking comfort and elegance.',
    agent: {
      name: 'Priya Sharma',
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
      phone: '+91 98765 43210',
      email: 'priya.sharma@marvelous.com',
    },
  },
  {
    id: 2,
    title: '4BHK Luxury Villa',
    type: 'Sale',
    location: 'Mumbai',
    price: '₹8.9 Cr',
    originalPrice: '₹9.5 Cr',
    image: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?w=800&auto=format',
    rating: 4.9,
    reviews: 56,
    beds: 4,
    baths: 4,
    sqft: 3500,
    featured: true,
    amenities: ['Pool', 'Garden', 'Gym', 'Spa', 'Security'],
    area: 'Juhu',
    description: 'Magnificent villa in Juhu with private pool and garden. Ideal for those who appreciate luxury and privacy.',
    agent: {
      name: 'Rajesh Kumar',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      phone: '+91 98765 43211',
      email: 'rajesh.kumar@marvelous.com',
    },
  },
  {
    id: 3,
    title: '2BHK Modern Apartment',
    type: 'Sale',
    location: 'Mumbai',
    price: '₹1.2 Cr',
    originalPrice: '₹1.35 Cr',
    image: 'https://images.unsplash.com/photo-1560448204-603b3fc33ddc?w=800&auto=format',
    rating: 4.6,
    reviews: 42,
    beds: 2,
    baths: 2,
    sqft: 1100,
    featured: false,
    amenities: ['Gym', 'Parking', 'Power Backup'],
    area: 'Andheri East',
    description: 'Modern apartment in Andheri East with excellent connectivity. Perfect for young professionals.',
    agent: {
      name: 'Anita Desai',
      avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
      phone: '+91 98765 43212',
      email: 'anita.desai@marvelous.com',
    },
  },
  {
    id: 4,
    title: '3BHK Fully Furnished Apartment',
    type: 'Rent',
    location: 'Mumbai',
    price: '₹65,000/month',
    originalPrice: '₹75,000/month',
    image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&auto=format',
    rating: 4.7,
    reviews: 67,
    beds: 3,
    baths: 3,
    sqft: 1500,
    featured: true,
    amenities: ['Furnished', 'Pool', 'Gym', 'Parking'],
    area: 'Worli',
    description: 'Fully furnished apartment in Worli with modern amenities and sea views.',
    agent: {
      name: 'Vikram Mehta',
      avatar: 'https://randomuser.me/api/portraits/men/75.jpg',
      phone: '+91 98765 43213',
      email: 'vikram.mehta@marvelous.com',
    },
  },
  {
    id: 5,
    title: '2BHK Semi-Furnished Apartment',
    type: 'Rent',
    location: 'Mumbai',
    price: '₹42,000/month',
    originalPrice: '₹48,000/month',
    image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&auto=format',
    rating: 4.5,
    reviews: 38,
    beds: 2,
    baths: 2,
    sqft: 1050,
    featured: false,
    amenities: ['Semi-Furnished', 'Parking', 'Gym'],
    area: 'Powai',
    description: 'Semi-furnished apartment in Powai near IT parks. Great for working professionals.',
    agent: {
      name: 'Amit Shah',
      avatar: 'https://randomuser.me/api/portraits/men/52.jpg',
      phone: '+91 98765 43214',
      email: 'amit.shah@marvelous.com',
    },
  },
  {
    id: 6,
    title: '1BHK Studio Apartment',
    type: 'Rent',
    location: 'Mumbai',
    price: '₹28,000/month',
    originalPrice: '₹32,000/month',
    image: 'https://images.unsplash.com/photo-1536376072261-38c75010e6c9?w=800&auto=format',
    rating: 4.4,
    reviews: 51,
    beds: 1,
    baths: 1,
    sqft: 600,
    featured: false,
    amenities: ['Furnished', 'WiFi', 'Gym'],
    area: 'Lower Parel',
    description: 'Cozy studio apartment in Lower Parel. Perfect for singles or couples.',
    agent: {
      name: 'Neha Gupta',
      avatar: 'https://randomuser.me/api/portraits/women/63.jpg',
      phone: '+91 98765 43215',
      email: 'neha.gupta@marvelous.com',
    },
  },
  {
    id: 7,
    title: '3BHK Garden View Apartment',
    type: 'Rent',
    location: 'Mumbai',
    price: '₹58,000/month',
    originalPrice: '₹65,000/month',
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&auto=format',
    rating: 4.6,
    reviews: 34,
    beds: 3,
    baths: 2,
    sqft: 1350,
    featured: false,
    amenities: ['Garden', 'Gym', 'Parking', 'Security'],
    area: 'Dadar',
    description: 'Beautiful garden view apartment in Dadar. Spacious and well-maintained.',
    agent: {
      name: 'Rajesh Kumar',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      phone: '+91 98765 43216',
      email: 'rajesh.kumar@marvelous.com',
    },
  },
  {
    id: 8,
    title: '2BHK Renovated Apartment',
    type: 'Sale',
    location: 'Mumbai',
    price: '₹1.8 Cr',
    originalPrice: '₹2.1 Cr',
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&auto=format',
    rating: 4.5,
    reviews: 27,
    beds: 2,
    baths: 2,
    sqft: 1150,
    featured: false,
    amenities: ['Gym', 'Parking', 'Security'],
    area: 'Chembur',
    description: 'Recently renovated apartment in Chembur. Modern finishes and great location.',
    agent: {
      name: 'Anita Desai',
      avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
      phone: '+91 98765 43217',
      email: 'anita.desai@marvelous.com',
    },
  },
  {
    id: 9,
    title: '3BHK Premium Apartment',
    type: 'Sale',
    location: 'Pune',
    price: '₹1.5 Cr',
    originalPrice: '₹1.7 Cr',
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&auto=format',
    rating: 4.7,
    reviews: 67,
    beds: 3,
    baths: 3,
    sqft: 1650,
    featured: true,
    amenities: ['Pool', 'Gym', 'Club House', 'Parking'],
    area: 'Koregaon Park',
    description: 'Premium apartment in Koregaon Park. Luxury living in Pune\'s most sought-after area.',
    agent: {
      name: 'Sanjay Joshi',
      avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
      phone: '+91 98765 43218',
      email: 'sanjay.joshi@marvelous.com',
    },
  },
  {
    id: 10,
    title: '4BHK Independent House',
    type: 'Sale',
    location: 'Pune',
    price: '₹2.8 Cr',
    originalPrice: '₹3.2 Cr',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&auto=format',
    rating: 4.8,
    reviews: 34,
    beds: 4,
    baths: 4,
    sqft: 2800,
    featured: true,
    amenities: ['Garden', 'Parking', 'Security', 'Modular Kitchen'],
    area: 'Kalyani Nagar',
    description: 'Independent house in Kalyani Nagar with garden. Perfect for large families.',
    agent: {
      name: 'Rajeshwari Patil',
      avatar: 'https://randomuser.me/api/portraits/women/33.jpg',
      phone: '+91 98765 43219',
      email: 'rajeshwari.patil@marvelous.com',
    },
  },
  {
    id: 11,
    title: '2BHK Affordable Apartment',
    type: 'Sale',
    location: 'Pune',
    price: '₹85 Lakhs',
    originalPrice: '₹95 Lakhs',
    image: 'https://images.unsplash.com/photo-1560448204-603b3fc33ddc?w=800&auto=format',
    rating: 4.5,
    reviews: 28,
    beds: 2,
    baths: 2,
    sqft: 1050,
    featured: false,
    amenities: ['Parking', 'Security', 'Power Backup'],
    area: 'Wakad',
    description: 'Affordable apartment in Wakad. Great value for money.',
    agent: {
      name: 'Amit Shah',
      avatar: 'https://randomuser.me/api/portraits/men/52.jpg',
      phone: '+91 98765 43220',
      email: 'amit.shah@marvelous.com',
    },
  },
  {
    id: 12,
    title: '3BHK Fully Furnished',
    type: 'Rent',
    location: 'Pune',
    price: '₹38,000/month',
    originalPrice: '₹45,000/month',
    image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&auto=format',
    rating: 4.6,
    reviews: 42,
    beds: 3,
    baths: 3,
    sqft: 1450,
    featured: true,
    amenities: ['Furnished', 'Gym', 'Pool', 'Parking'],
    area: 'Hinjewadi',
    description: 'Fully furnished apartment in Hinjewadi. Ideal for IT professionals.',
    agent: {
      name: 'Pooja Deshmukh',
      avatar: 'https://randomuser.me/api/portraits/women/57.jpg',
      phone: '+91 98765 43221',
      email: 'pooja.deshmukh@marvelous.com',
    },
  },
  {
    id: 13,
    title: '2BHK Semi-Furnished',
    type: 'Rent',
    location: 'Pune',
    price: '₹22,000/month',
    originalPrice: '₹25,000/month',
    image: 'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?w=800&auto=format',
    rating: 4.4,
    reviews: 45,
    beds: 2,
    baths: 2,
    sqft: 1100,
    featured: false,
    amenities: ['Parking', 'Security', 'Power Backup'],
    area: 'Aundh',
    description: 'Semi-furnished apartment in Aundh. Convenient location.',
    agent: {
      name: 'Karan Singh',
      avatar: 'https://randomuser.me/api/portraits/men/86.jpg',
      phone: '+91 98765 43222',
      email: 'karan.singh@marvelous.com',
    },
  },
  {
    id: 14,
    title: '1BHK Furnished Apartment',
    type: 'Rent',
    location: 'Pune',
    price: '₹16,000/month',
    originalPrice: '₹18,000/month',
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&auto=format',
    rating: 4.3,
    reviews: 52,
    beds: 1,
    baths: 1,
    sqft: 650,
    featured: false,
    amenities: ['Furnished', 'WiFi', 'Gym'],
    area: 'Viman Nagar',
    description: 'Furnished 1BHK in Viman Nagar. Close to airport and shopping.',
    agent: {
      name: 'Neha Gupta',
      avatar: 'https://randomuser.me/api/portraits/women/63.jpg',
      phone: '+91 98765 43223',
      email: 'neha.gupta@marvelous.com',
    },
  },
  {
    id: 15,
    title: '3BHK Luxury Apartment',
    type: 'Sale',
    location: 'Pune',
    price: '₹2.2 Cr',
    originalPrice: '₹2.5 Cr',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&auto=format',
    rating: 4.8,
    reviews: 31,
    beds: 3,
    baths: 3,
    sqft: 1750,
    featured: true,
    amenities: ['Pool', 'Gym', 'Club House', 'Security'],
    area: 'Baner',
    description: 'Luxury apartment in Baner with premium amenities.',
    agent: {
      name: 'Sanjay Joshi',
      avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
      phone: '+91 98765 43224',
      email: 'sanjay.joshi@marvelous.com',
    },
  },
  {
    id: 16,
    title: '2BHK Vastu Apartment',
    type: 'Sale',
    location: 'Pune',
    price: '₹95 Lakhs',
    originalPrice: '₹1.1 Cr',
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&auto=format',
    rating: 4.5,
    reviews: 22,
    beds: 2,
    baths: 2,
    sqft: 1080,
    featured: false,
    amenities: ['Parking', 'Security', 'Power Backup'],
    area: 'Pimpri',
    description: 'Vastu-compliant apartment in Pimpri. Positive energy and good location.',
    agent: {
      name: 'Rajesh Kumar',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      phone: '+91 98765 43225',
      email: 'rajesh.kumar@marvelous.com',
    },
  },
  {
    id: 17,
    title: 'Penthouse with Terrace',
    type: 'Sale',
    location: 'Pune',
    price: '₹2.1 Cr',
    originalPrice: '₹2.4 Cr',
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&auto=format',
    rating: 4.9,
    reviews: 28,
    beds: 3,
    baths: 3,
    sqft: 2100,
    featured: true,
    amenities: ['Private Terrace', 'Pool', 'Gym', 'Club House'],
    area: 'Wakad',
    description: 'Stunning penthouse with private terrace in Wakad. Breathtaking views.',
    agent: {
      name: 'Rajeshwari Patil',
      avatar: 'https://randomuser.me/api/portraits/women/33.jpg',
      phone: '+91 98765 43226',
      email: 'rajeshwari.patil@marvelous.com',
    },
  },
  {
    id: 18,
    title: 'Executive Corporate Suite',
    type: 'Corporate',
    location: 'Mumbai',
    price: '₹15,000/night',
    originalPrice: '₹18,000/night',
    image: 'https://images.pexels.com/photos/271624/pexels-photo-271624.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.9,
    reviews: 78,
    beds: 3,
    baths: 3,
    sqft: 2000,
    featured: true,
    amenities: ['Room Service', 'Conference Room', 'WiFi', 'Gym'],
    area: 'BKC',
    description: 'Executive corporate suite in BKC. Perfect for business travelers.',
    agent: {
      name: 'Rahul Singh',
      avatar: 'https://randomuser.me/api/portraits/men/97.jpg',
      phone: '+91 98765 43227',
      email: 'rahul.singh@marvelous.com',
    },
  },
  {
    id: 19,
    title: 'Corporate Guest House',
    type: 'Corporate',
    location: 'Mumbai',
    price: '₹12,000/night',
    originalPrice: '₹14,000/night',
    image: 'https://images.unsplash.com/photo-1566665797739-1674de7a421a?w=800&auto=format',
    rating: 4.8,
    reviews: 62,
    beds: 2,
    baths: 2,
    sqft: 1500,
    featured: false,
    amenities: ['Business Center', 'Gym', 'WiFi', 'Parking'],
    area: 'Andheri East',
    description: 'Corporate guest house near airport. Ideal for short stays.',
    agent: {
      name: 'Pooja Malhotra',
      avatar: 'https://randomuser.me/api/portraits/women/24.jpg',
      phone: '+91 98765 43228',
      email: 'pooja.malhotra@marvelous.com',
    },
  },
  {
    id: 20,
    title: 'Business Executive Suite',
    type: 'Corporate',
    location: 'Pune',
    price: '₹10,000/night',
    originalPrice: '₹12,000/night',
    image: 'https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=800&auto=format',
    rating: 4.8,
    reviews: 44,
    beds: 2,
    baths: 2,
    sqft: 1400,
    featured: true,
    amenities: ['Conference Room', 'WiFi', 'Gym', 'Business Center'],
    area: 'Hinjewadi',
    description: 'Business executive suite in Hinjewadi. Close to IT parks.',
    agent: {
      name: 'Karan Johar',
      avatar: 'https://randomuser.me/api/portraits/men/12.jpg',
      phone: '+91 98765 43229',
      email: 'karan.johar@marvelous.com',
    },
  },
  {
    id: 21,
    title: 'Corporate Apartment',
    type: 'Corporate',
    location: 'Pune',
    price: '₹9,500/night',
    originalPrice: '₹11,000/night',
    image: 'https://images.unsplash.com/photo-1554995207-c18c203602cb?w=800&auto=format',
    rating: 4.7,
    reviews: 36,
    beds: 2,
    baths: 2,
    sqft: 1300,
    featured: false,
    amenities: ['Kitchen', 'WiFi', 'Parking', 'Gym'],
    area: 'Koregaon Park',
    description: 'Corporate apartment in Koregaon Park. Home away from home.',
    agent: {
      name: 'Anjali Mehta',
      avatar: 'https://randomuser.me/api/portraits/women/55.jpg',
      phone: '+91 98765 43230',
      email: 'anjali.mehta@marvelous.com',
    },
  }
];

// Amenities icons
const amenityIcons = {
  Pool: <Pool />,
  Gym: <FitnessCenter />,
  Parking: <LocalParking />,
  WiFi: <Wifi />,
  'Conference Room': <Business />,
  Security: <Shield />,
  Garden: <Spa />,
  'Room Service': <Restaurant />,
  'Business Center': <Business />,
  Kitchen: <Restaurant />,
  'Private Terrace': <Weekend />,
  'Modular Kitchen': <Restaurant />,
  'Club House': <Business />,
  'Power Backup': <Speed />,
  'Furnished': <Home />,
  'Semi-Furnished': <Home />,
};

// Property types
const propertyTypes = ['All', 'Sale', 'Rent', 'Buy', 'Corporate'];

// Locations
const locations = ['All', 'Mumbai', 'Pune'];

// Featured cities with images
const featuredCities = [
  {
    name: 'Mumbai',
    image: 'https://images.unsplash.com/photo-1529253355930-ddbe423a2ac7?w=600&h=400&auto=format',
    count: 9,
    color: '#9b4d3c',
  },
  {
    name: 'Pune',
    image: 'https://images.unsplash.com/photo-1560439514-4e9645039924?w=600&h=400&auto=format',
    count: 12,
    color: '#d49b7b',
  },
];

// Section border style - THICKER (2x) matching homepage
const sectionBorderStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  height: '4px',
  background: 'linear-gradient(90deg, #9b4d3c 0%, #d49b7b 50%, #e0e0e0 100%)',
  zIndex: 1,
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
};

// Title style with moving underline
const titleWithUnderlineStyle = {
  fontWeight: 600,
  color: '#333',
  fontSize: { xs: '2rem', md: '2.5rem' },
  position: 'relative',
  display: 'inline-block',
  pb: 2,
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 80,
    height: 3,
    background: 'linear-gradient(90deg, #9b4d3c, #d49b7b)',
    borderRadius: 2,
    animation: 'pulseWidth 2s ease-in-out infinite',
  }
};

// Property Details Modal Component
const PropertyDetailsModal = ({ open, onClose, property }) => {
  if (!property) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          border: '2px solid #9b4d3c',
          overflow: 'hidden',
        }
      }}
    >
      <DialogTitle sx={{ 
        bgcolor: '#9b4d3c', 
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 2,
      }}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {property.title}
        </Typography>
        <IconButton onClick={onClose} sx={{ color: 'white' }}>
          <Close />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ position: 'relative', height: 300 }}>
          <CardMedia
            component="img"
            image={property.image}
            alt={property.title}
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <Chip
            label={property.type}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              bgcolor: property.type === 'Sale' ? '#4caf50' :
                      property.type === 'Rent' ? '#2196f3' :
                      property.type === 'Corporate' ? '#ff9800' : '#9c27b0',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              height: 30,
            }}
          />
        </Box>

        <Box sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <LocationOn sx={{ color: '#9b4d3c', mr: 1 }} />
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {property.area}, {property.location}
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Star sx={{ color: '#d49b7b', mr: 1 }} />
                <Typography variant="body1" sx={{ fontWeight: 600, color: '#d49b7b', mr: 1 }}>
                  {property.rating}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ({property.reviews} reviews)
                </Typography>
              </Box>

              <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                {property.description}
              </Typography>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Bed sx={{ color: '#9b4d3c' }} />
                    <Box>
                      <Typography variant="body2" color="text.secondary">Beds</Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>{property.beds}</Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Bathtub sx={{ color: '#9b4d3c' }} />
                    <Box>
                      <Typography variant="body2" color="text.secondary">Baths</Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>{property.baths}</Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <SquareFoot sx={{ color: '#9b4d3c' }} />
                    <Box>
                      <Typography variant="body2" color="text.secondary">Area</Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>{property.sqft} sqft</Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#333' }}>
                Amenities
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 3 }}>
                {property.amenities.map((amenity, idx) => (
                  <Chip
                    key={idx}
                    icon={React.cloneElement(amenityIcons[amenity] || <Business />, { sx: { fontSize: 16 } })}
                    label={amenity}
                    sx={{
                      bgcolor: 'rgba(155,77,60,0.05)',
                      border: '1px solid #9b4d3c',
                      borderRadius: 2,
                      height: 36,
                      '& .MuiChip-icon': { color: '#9b4d3c' },
                    }}
                  />
                ))}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const RealEstatePage = () => {
  const [filters, setFilters] = useState({
    type: 'All',
    location: 'All',
  });
  const [page, setPage] = useState(1);
  const [favorites, setFavorites] = useState([]);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [heroVisible, setHeroVisible] = useState(true);
  const [imageErrors, setImageErrors] = useState({});
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const itemsPerPage = 6;

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
    setPage(1);
  };

  const handleCityClick = (city) => {
    setSelectedCity(city.name);
    setFilters({ ...filters, location: city.name });
  };

  const toggleFavorite = (propertyId) => {
    if (favorites.includes(propertyId)) {
      setFavorites(favorites.filter(id => id !== propertyId));
    } else {
      setFavorites([...favorites, propertyId]);
    }
  };

  const handleImageError = (propertyId) => {
    setImageErrors(prev => ({ ...prev, [propertyId]: true }));
  };

  const handleViewDetails = (property) => {
    setSelectedProperty(property);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedProperty(null);
  };

  // Completely unique fallback images - no duplicates here either
  const getFallbackImage = (propertyId) => {
    const uniqueFallbacks = {
      1: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&auto=format',
      2: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?w=800&auto=format',
      3: 'https://images.unsplash.com/photo-1560448204-603b3fc33ddc?w=800&auto=format',
      4: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&auto=format',
      5: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&auto=format',
      6: 'https://images.unsplash.com/photo-1536376072261-38c75010e6c9?w=800&auto=format',
      7: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&auto=format',
      8: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&auto=format',
      9: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&auto=format',
      10: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&auto=format',
      11: 'https://images.unsplash.com/photo-1560448204-603b3fc33ddc?w=800&auto=format',
      12: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&auto=format',
      13: 'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?w=800&auto=format',
      14: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&auto=format',
      15: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&auto=format',
      16: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&auto=format',
      17: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&auto=format',
      18: 'https://images.pexels.com/photos/271624/pexels-photo-271624.jpeg?auto=compress&cs=tinysrgb&w=800',
      19: 'https://images.unsplash.com/photo-1566665797739-1674de7a421a?w=800&auto=format',
      20: 'https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=800&auto=format',
      21: 'https://images.unsplash.com/photo-1554995207-c18c203602cb?w=800&auto=format',
    };
    return uniqueFallbacks[propertyId] || uniqueFallbacks[1];
  };

  // Filter properties
  const filteredProperties = allProperties.filter((property) => {
    if (filters.type !== 'All' && property.type !== filters.type) return false;
    if (filters.location !== 'All' && property.location !== filters.location) return false;
    return true;
  });

  const paginatedProperties = filteredProperties.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  // Update city counts
  const getCityCount = (cityName) => {
    return allProperties.filter(p => p.location === cityName).length;
  };

  const updatedFeaturedCities = featuredCities.map(city => ({
    ...city,
    count: getCityCount(city.name)
  }));

  return (
    <Box sx={{ bgcolor: '#faf7f2', minHeight: '100vh' }}>
      {/* Property Details Modal */}
      <PropertyDetailsModal
        open={modalOpen}
        onClose={handleCloseModal}
        property={selectedProperty}
      />

      {/* SECTION 1: HERO - No top border (matches homepage) */}
      <Box
        sx={{
          position: 'relative',
          height: '80vh',
          minHeight: 600,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            '&::after': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 50%, rgba(155,77,60,0.3) 100%)',
              zIndex: 1,
            }
          }}
        >
          <Box
            component="img"
            src="https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1920&h=1080&auto=format"
            alt="Luxury Modern Apartment"
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.3s ease-out',
            }}
          />
        </Box>

        <Container
          maxWidth="xl"
          sx={{
            position: 'relative',
            zIndex: 3,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            color: 'white',
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
              <Fade in={heroVisible} timeout={1000}>
                <Box>
                  <Fade in={heroVisible} timeout={1500}>
                    <Chip
                      label="LUXURY LIVING"
                      sx={{
                        bgcolor: 'rgba(212,155,123,0.15)',
                        color: '#d49b7b',
                        mb: 3,
                        fontWeight: 500,
                        border: '1px solid rgba(212,155,123,0.2)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          bgcolor: 'rgba(212,155,123,0.25)',
                          transform: 'translateY(-2px)',
                        },
                      }}
                    />
                  </Fade>
                  
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: { xs: '3rem', md: '4.5rem' },
                      fontWeight: 800,
                      mb: 2,
                      lineHeight: 1.1,
                      textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                    }}
                  >
                    <Fade in={heroVisible} timeout={1200}>
                      <span>Find Your</span>
                    </Fade>
                    <Box 
                      component="span" 
                      sx={{ 
                        color: '#d49b7b', 
                        display: 'block',
                      }}
                    >
                      <Fade in={heroVisible} timeout={1400}>
                        <span>Dream Home</span>
                      </Fade>
                    </Box>
                  </Typography>
                  
                  <Fade in={heroVisible} timeout={1600}>
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: { xs: '1.2rem', md: '1.5rem' },
                        fontWeight: 300,
                        mb: 0,
                        opacity: 0.9,
                        maxWidth: 600,
                      }}
                    >
                      Luxury properties in Mumbai & Pune tailored to your lifestyle
                    </Typography>
                  </Fade>
                </Box>
              </Fade>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* SECTION 2: HEADER - With thicker gradient top border and centered title with moving underline */}
      <Box sx={{ position: 'relative' }}>
        <Box sx={sectionBorderStyle} />
        <Container maxWidth="xl" sx={{ py: 4 }}>
          <Fade in={true} timeout={800}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography 
                variant="overline" 
                sx={{ 
                  color: '#9b4d3c', 
                  fontSize: '0.9rem', 
                  letterSpacing: 4,
                  fontWeight: 500,
                  display: 'block',
                  mb: 1,
                }}
              >
                FIND YOUR DREAM PROPERTY
              </Typography>
              <Typography 
                variant="h2" 
                component="h1" 
                sx={titleWithUnderlineStyle}
              >
                Explore Properties
              </Typography>
              <Typography 
                variant="body1" 
                color="text.secondary" 
                sx={{ 
                  maxWidth: 600, 
                  mx: 'auto',
                  mt: 4,
                }}
              >
                Discover luxury properties in Mumbai and Pune tailored to your lifestyle and investment needs
              </Typography>
            </Box>
          </Fade>
        </Container>
      </Box>

      {/* SECTION 3: FEATURED CITIES - With thicker gradient top border and centered title with moving underline */}
      <Box sx={{ position: 'relative' }}>
        <Box sx={sectionBorderStyle} />
        <Container maxWidth="xl" sx={{ py: { xs: 6, md: 8 } }}>
          <Fade in={true} timeout={800}>
            <Box sx={{ textAlign: 'center', mb: 6 }}>
              <Typography 
                variant="h2" 
                sx={titleWithUnderlineStyle}
              >
                Explore by City
              </Typography>
            </Box>
          </Fade>
          <Grid container spacing={4}>
            {updatedFeaturedCities.map((city, index) => (
              <Grid item xs={12} md={6} key={city.name}>
                <Fade in={true} timeout={1000 + index * 200}>
                  <Card
                    sx={{
                      position: 'relative',
                      height: 300,
                      cursor: 'pointer',
                      overflow: 'hidden',
                      borderRadius: 3,
                      boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
                      border: '2px solid #9b4d3c',
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'translateY(-8px)',
                        boxShadow: '0 20px 40px rgba(155,77,60,0.25)',
                        '& .city-image': {
                          transform: 'scale(1.08)',
                        },
                        '& .city-overlay': {
                          opacity: 0.8,
                        },
                      },
                    }}
                    onClick={() => handleCityClick(city)}
                  >
                    <CardMedia
                      component="img"
                      image={city.image}
                      alt={city.name}
                      className="city-image"
                      sx={{
                        height: '100%',
                        transition: 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                      }}
                    />
                    <Box
                      className="city-overlay"
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: `linear-gradient(135deg, ${city.color} 0%, ${city.color}99 100%)`,
                        opacity: 0.7,
                        transition: 'opacity 0.4s ease',
                      }}
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        p: 4,
                        color: 'white',
                        zIndex: 2,
                        background: 'linear-gradient(to top, rgba(0,0,0,0.3), transparent)',
                        transition: 'transform 0.4s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                        },
                      }}
                    >
                      <Typography variant="h2" sx={{ fontWeight: 700, mb: 1, fontSize: { xs: '2.5rem', md: '3rem' } }}>
                        {city.name}
                      </Typography>
                      <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 400 }}>
                        {city.count} Properties Available
                      </Typography>
                    </Box>
                  </Card>
                </Fade>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* SECTION 4: AVAILABLE PROPERTIES - CENTERED WITH MOVING UNDERLINE */}
      <Box sx={{ position: 'relative' }}>
        <Box sx={sectionBorderStyle} />
        <Container maxWidth="xl" sx={{ py: { xs: 6, md: 8 } }}>
          {/* Available Properties Header - Centered with moving underline */}
          <Fade in={true} timeout={800}>
            <Box sx={{ textAlign: 'center', mb: 6 }}>
              <Typography 
                variant="h2" 
                component="h2" 
                sx={titleWithUnderlineStyle}
              >
                Available Properties
              </Typography>
              <Typography 
                variant="body1" 
                color="text.secondary"
                sx={{ mt: 2 }}
              >
                {filteredProperties.length} properties found
              </Typography>
            </Box>
          </Fade>

          {/* Filter Section - Single Paper with Two Dropdowns Side by Side */}
          <Fade in={true} timeout={800}>
            <Paper
              sx={{
                p: 4,
                borderRadius: 3,
                bgcolor: 'white',
                boxShadow: '0 5px 20px rgba(155,77,60,0.05)',
                border: '2px solid #d49b7b',
                transition: 'box-shadow 0.3s ease, transform 0.3s ease',
                '&:hover': {
                  boxShadow: '0 15px 30px rgba(155,77,60,0.15)',
                },
              }}
            >
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Property Type</InputLabel>
                    <Select
                      value={filters.type}
                      label="Property Type"
                      onChange={(e) => handleFilterChange('type', e.target.value)}
                      sx={{
                        borderRadius: 2,
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#9b4d3c',
                          },
                        },
                      }}
                    >
                      {propertyTypes.map((type) => (
                        <MenuItem key={type} value={type}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {type === 'Sale' && <TrendingUp fontSize="small" sx={{ color: '#4caf50' }} />}
                            {type === 'Rent' && <Home fontSize="small" sx={{ color: '#2196f3' }} />}
                            {type === 'Buy' && <Business fontSize="small" sx={{ color: '#9c27b0' }} />}
                            {type === 'Corporate' && <Hotel fontSize="small" sx={{ color: '#ff9800' }} />}
                            {type === 'All' && <Apartment fontSize="small" sx={{ color: '#9b4d3c' }} />}
                            <Typography>{type}</Typography>
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Location</InputLabel>
                    <Select
                      value={filters.location}
                      label="Location"
                      onChange={(e) => handleFilterChange('location', e.target.value)}
                      sx={{
                        borderRadius: 2,
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#9b4d3c',
                          },
                        },
                      }}
                    >
                      {locations.map((loc) => (
                        <MenuItem key={loc} value={loc}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LocationOn fontSize="small" sx={{ color: '#9b4d3c' }} />
                            <Typography>{loc}</Typography>
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {(filters.type !== 'All' || filters.location !== 'All') && (
                <Fade in={true} timeout={500}>
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                      Active Filters:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      {filters.type !== 'All' && (
                        <Chip
                          label={filters.type}
                          onDelete={() => handleFilterChange('type', 'All')}
                          sx={{ 
                            bgcolor: 'rgba(155,77,60,0.1)',
                            color: '#9b4d3c',
                            '& .MuiChip-deleteIcon': { color: '#9b4d3c' },
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              bgcolor: 'rgba(155,77,60,0.2)',
                            },
                          }}
                          size="small"
                        />
                      )}
                      {filters.location !== 'All' && (
                        <Chip
                          label={filters.location}
                          onDelete={() => handleFilterChange('location', 'All')}
                          sx={{ 
                            bgcolor: 'rgba(155,77,60,0.1)',
                            color: '#9b4d3c',
                            '& .MuiChip-deleteIcon': { color: '#9b4d3c' },
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              bgcolor: 'rgba(155,77,60,0.2)',
                            },
                          }}
                          size="small"
                        />
                      )}
                    </Box>
                  </Box>
                </Fade>
              )}
            </Paper>
          </Fade>
        </Container>
      </Box>

      {/* SECTION 5: PROPERTY GRID */}
      {paginatedProperties.length > 0 ? (
        <Container maxWidth="xl" sx={{ py: { xs: 6, md: 8 } }}>
          <Grid container spacing={4}>
            {paginatedProperties.map((property, index) => (
              <Grid item xs={12} sm={6} md={4} key={property.id}>
                <Grow in={true} timeout={500 + index * 100}>
                  <Card
                    onMouseEnter={() => setHoveredCard(property.id)}
                    onMouseLeave={() => setHoveredCard(null)}
                    sx={{
                      height: '100%',
                      borderRadius: 3,
                      overflow: 'hidden',
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      boxShadow: hoveredCard === property.id 
                        ? '0 25px 50px rgba(155,77,60,0.25)' 
                        : '0 5px 20px rgba(0,0,0,0.05)',
                      border: '2px solid #9b4d3c',
                      position: 'relative',
                      transform: hoveredCard === property.id ? 'translateY(-8px)' : 'translateY(0)',
                      '&:hover': {
                        borderColor: '#d49b7b',
                      },
                    }}
                  >
                    {property.featured && (
                      <Zoom in={true} timeout={500}>
                        <Chip
                          label="FEATURED"
                          size="small"
                          sx={{
                            position: 'absolute',
                            top: 15,
                            left: 15,
                            zIndex: 2,
                            bgcolor: '#9b4d3c',
                            color: 'white',
                            fontSize: '0.7rem',
                            height: 24,
                            fontWeight: 'bold',
                          }}
                        />
                      </Zoom>
                    )}
                    
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: 15,
                        right: 15,
                        zIndex: 2,
                        bgcolor: 'white',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          bgcolor: '#f5f5f5',
                          transform: 'scale(1.1)',
                        },
                      }}
                      onClick={() => toggleFavorite(property.id)}
                    >
                      {favorites.includes(property.id) ? (
                        <Favorite sx={{ color: '#9b4d3c', fontSize: 20 }} />
                      ) : (
                        <FavoriteBorder sx={{ fontSize: 20 }} />
                      )}
                    </IconButton>

                    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
                      <CardMedia
                        component="img"
                        height="220"
                        image={imageErrors[property.id] ? getFallbackImage(property.id) : property.image}
                        alt={property.title}
                        onError={() => handleImageError(property.id)}
                        sx={{
                          transition: 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                          transform: hoveredCard === property.id ? 'scale(1.08)' : 'scale(1)',
                        }}
                      />
                    </Box>

                    <CardContent sx={{ p: 2.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem', color: '#333' }}>
                          {property.title}
                        </Typography>
                        <Chip
                          label={property.type}
                          size="small"
                          sx={{
                            bgcolor: property.type === 'Sale' ? '#4caf50' :
                                    property.type === 'Rent' ? '#2196f3' :
                                    property.type === 'Buy' ? '#9c27b0' : '#ff9800',
                            color: 'white',
                            fontSize: '0.7rem',
                            height: 22,
                            fontWeight: 'bold',
                          }}
                        />
                      </Box>

                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                        <LocationOn sx={{ fontSize: 16, color: '#9b4d3c', mr: 0.5 }} />
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                          {property.area}, {property.location}
                        </Typography>
                      </Box>

                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Star sx={{ fontSize: 16, color: '#d49b7b', mr: 0.5 }} />
                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#d49b7b', mr: 1 }}>
                          {property.rating}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          ({property.reviews} reviews)
                        </Typography>
                      </Box>

                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleViewDetails(property)}
                        sx={{
                          bgcolor: '#9b4d3c',
                          color: 'white',
                          py: 1,
                          borderRadius: 2,
                          fontWeight: 600,
                          fontSize: '0.9rem',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            bgcolor: '#7a3b2e',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 5px 15px rgba(155,77,60,0.3)',
                          },
                        }}
                      >
                        View Details
                      </Button>
                    </CardContent>
                  </Card>
                </Grow>
              </Grid>
            ))}
          </Grid>
        </Container>
      ) : (
        <Container maxWidth="xl" sx={{ py: { xs: 6, md: 8 } }}>
          <Fade in={true} timeout={800}>
            <Paper
              sx={{
                p: 6,
                textAlign: 'center',
                borderRadius: 3,
                bgcolor: 'white',
                border: '2px solid #9b4d3c',
              }}
            >
              <Zoom in={true} timeout={500}>
                <Apartment sx={{ fontSize: 60, color: '#9b4d3c', mb: 2 }} />
              </Zoom>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                No Properties Found
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                We couldn't find any properties matching your criteria.
                Try adjusting your filters.
              </Typography>
              <Button
                variant="contained"
                onClick={() => setFilters({ type: 'All', location: 'All' })}
                sx={{ 
                  bgcolor: '#9b4d3c',
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    bgcolor: '#7a3b2e',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 5px 15px rgba(155,77,60,0.3)',
                  },
                }}
              >
                Clear All Filters
              </Button>
            </Paper>
          </Fade>
        </Container>
      )}

      {/* SECTION 6: PAGINATION - With thicker gradient top border */}
      {filteredProperties.length > itemsPerPage && (
        <Box sx={{ position: 'relative' }}>
          <Box sx={sectionBorderStyle} />
          <Container maxWidth="xl" sx={{ py: 4 }}>
            <Fade in={true} timeout={800}>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Pagination
                  count={Math.ceil(filteredProperties.length / itemsPerPage)}
                  page={page}
                  onChange={(e, val) => setPage(val)}
                  color="primary"
                  size="large"
                  showFirstButton
                  showLastButton
                  sx={{
                    '& .MuiPaginationItem-root': {
                      color: '#9b4d3c',
                      border: '2px solid #9b4d3c',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        bgcolor: 'rgba(155,77,60,0.1)',
                      },
                    },
                    '& .Mui-selected': {
                      bgcolor: '#9b4d3c !important',
                      color: 'white',
                      border: '2px solid #9b4d3c',
                    },
                  }}
                />
              </Box>
            </Fade>
          </Container>
        </Box>
      )}
      
      {/* Add keyframe animation for the moving underline */}
      <style>
        {`
          @keyframes pulseWidth {
            0%, 100% { width: 80px; }
            50% { width: 120px; }
          }
        `}
      </style>
    </Box>
  );
};

export default RealEstatePage;